@tailwind base;
@tailwind components;
@tailwind utilities;


.ids-modal[open] {
  --ids-comp-modal-footer-gap: 1rem;
  --ids-comp-modal-width: min(90%, 30rem);
  display: flex;
  height: fit-content;
}

.ids-modal:not([open]) {
  display: none;
}
